var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27592 4.25513C6.2757 4.69887 6.09921 5.12435 5.78529 5.43796C5.47136 5.75157 5.04571 5.92763 4.60197 5.92741C4.15823 5.92719 3.73275 5.7507 3.41914 5.43678C3.10553 5.12285 2.92947 4.6972 2.92969 4.25346C2.92991 3.80972 3.1064 3.38424 3.42032 3.07063C3.73425 2.75702 4.1599 2.58096 4.60364 2.58118C5.04738 2.5814 5.47286 2.75789 5.78647 3.07181C6.10008 3.38574 6.27614 3.81139 6.27592 4.25513ZM6.32612 7.16636H2.97988V17.6401H6.32612V7.16636ZM11.6132 7.16636H8.28366V17.6401H11.5797V12.1439C11.5797 9.08208 15.5701 8.79765 15.5701 12.1439V17.6401H18.8745V11.0062C18.8745 5.84459 12.9684 6.037 11.5797 8.57177L11.6132 7.16636Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c2cb02b2790ce221fa26a8362f09d4e2.svg";
export { ForwardRef as ReactComponent };